import Option from "../components/systemAdmin/Option";
export const getControlValues = (data) => {
    const details = {};

    data.forEach((row, rowIndex) => {
      row.cellData.forEach((cell, cellIndex) => {
        if (cell.type === "control") {
          details[cell.data.code] = Option.getValue(cell.data);
        }
      })
    })

    return details;
  }